<template>
  <div class="couponPanel" >
			<!--	{{$root.cart}}-->
						
			 <b-row class="pt-2">
					<b-col v-if="$root.cart.coupon_applied==0">
						<span style="font-size: 12px;"> Apply Coupon here to get discount immediately.
						
						</span>
						<b-input-group size="sm" class="mb-3" >
							<b-form-input placeholder="Have a coupon?" v-model="couponApply" class="ficp"></b-form-input>
							<b-input-group-append>
								<b-button  type="button" size="sm"  variant="outline-primary"  @click="$root.applycoupon(couponApply,'apply')"  class="ficbtnApply">Apply</b-button>
								
								
														
							</b-input-group-append>
						</b-input-group>
					</b-col>
					
					<b-col v-else>
						<span style="font-size: 12px;"> Apply Coupon here to get discount immediately. </span>
						<b-input-group size="sm" >
							<b-form-input placeholder="Have a coupon?" v-model="couponApply" class="ficp" disabled style="background: #fff"></b-form-input>
							<b-input-group-append>
								
								<b-button  type="button" size="sm"  variant="outline-primary"  @click=" $root.applycoupon(couponApply,'remove');" class="ficbtnRemove">Remove</b-button>
														<!-- couponApply='';-->
							</b-input-group-append>
						</b-input-group>
						<small style="font-size: 12px;color:#668141;"> <i class="fa fa-check-circle" aria-hidden="true" style="color:#668141;font-size: 14px;"></i> coupon code {{couponApply}} is applied successfully.
						
						</small>
					</b-col>
					
				</b-row> 
    
  </div>
</template>
<script>
export default {
  name: 'couponPanel', 
  props: {
    //totalPay: { type: Number }
    //cartItemslist: { type: Object }
  },
  mounted(){
  if(this.$root.cart.coupon_applied==1){
  this.couponApply=this.$root.cart.coupon.code;
  }
  this.inLodcard;
  
  
  },
  computed: {
    //
  },
  data() {
    return{
	couponApply:'',
      //modaldata_qty: 1,
	  //variant:'dark',
	  //cartHeader:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
	 inLodcard(){
	 if(this.$root.cart.coupon_applied==1){
		this.couponApply =this.$root.cart.coupon.code;
	 }
	
	} 
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	.couponPanel{
		.ficp{
			border-right:0px;
		}
		.ficbtnApply{
			border:1px solid #ced4da;
			border-left:0px;
			color:#c85df7;
		}
		.ficbtnRemove{
			border:1px solid #ced4da;
			border-left:0px;
			color:red;
			
		}
		
		.input-group-append{
			.btn-outline-primary{
				&:hover {
					color: red;
					background-color: #fff;
					border-color: #ced4da;
				}
				&::focus {
					box-shadow: none;
				}
			}
		}
	
	
	}

</style>
